<template>
	<section>
		<div v-if="$i18n.locale == 'hu' && description">
			<h2 class="title">{{ $t('Description') }}</h2>
			<p>{{ description }}</p>
		</div>
		<div v-if="$i18n.locale == 'en' && ((typeof long_description != 'undefined' && long_description.en.description) || description)">
			<h2 class="title">{{ $t('Description') }}</h2>
			<p>
				{{
					typeof long_description != 'undefined' && long_description.en.description
						? long_description.en.description
						: description
				}}
			</p>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		long_description: {},
		description: {
			required: false,
			type: String,
		},
	},
}
</script>
